<template>
  <div class="nav-wrap">
    <div class="w clearfix">
      <div class="select-nav Fl-l">
        <i class="el-icon el-icon-arrow-left" @click="switchCategoryLeft"></i>
        {{ curCategory }}
        <i class="el-icon el-icon-arrow-right" @click="switchCategoryRight"></i>
        <ul class="sub-nav" v-if="secondCategory.length > 0">
          <li
            v-for="item in secondCategory"
            :key="item.category_id"
            @mouseenter="showThirdCategory(item)"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="third-nav" v-if="thirdCategory.length > 0">
          <el-row v-for="item in thirdCategory" :key="item.category_id">
            <routerLink
              :to="{
                name: 'products-list',
                query: { type: curCategoryType, category_id: item.category_id }
              }"
              class="category-name"
              >{{ item.name }}</routerLink
            >
            <div class="fourth-nav">
              <routerLink
                :to="{
                  name: 'products-list',
                  query: { type: curCategoryType, category_id: i.category_id }
                }"
                v-for="i in item.categories"
                :key="i.category_id"
                >| {{ i.name }}</routerLink
              >
            </div>
          </el-row>
        </div>
      </div>
      <routerLink
        :to="{ name: 'index' }"
        :class="{ actived: curCategoryType === 'home' }"
        @click.native="clickCategory('home')"
        >首页</routerLink
      >
      <routerLink
        :to="{
          name: 'category-home',
          query: { type: item.type, id: item.category_id }
        }"
        :class="{ actived: curCategoryType === item.type }"
        v-for="(item, index) in category"
        v-if="index < 6"
        :key="item.category_id"
        @click.native="clickCategory(item)"
        >{{ item.name }}</routerLink
      >
      <!-- <span>
        <img src="../assets/images/safe.png" alt align="center"> 正品行货，精致服务
      </span>-->
    </div>
    <div class="headline"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      category: [],
      curCategory: "",
      curCategoryType: "home",
      curCategoryIndex: 0,
      secondCategory: [],
      thirdCategory: [],
      fourthCategory: [],
      userRule: false,
      activity_id: "",
      name: ""
    };
  },
  created() {
    this.name = window.sessionStorage.getItem("name");
    this.$bus.$off("change-activity");
    this.$bus.on("change-activity", this.getSlides);
    this.$bus.$off("change-type");
    this.$bus.on("change-type", this.clickCategory);
  },
  mounted() {
    this.activity_id = sessionStorage.getItem("activityId");
    this.getSlides();
  },
  methods: {
    getSlides(res) {
      // if(!this.activity_id){
      //   this.getCateList();
      //   return
      // }
      // this.$reqGet("api/store/activities/" + this.activity_id)
      // .then((res) => {
      if (res && res.data && res.data.success) {
        if (res.data.data.products && res.data.data.products.not_use_rule) {
          this.userRule = true;
        } else {
          this.userRule = false;
        }
      }
      this.getCateList();
      // })
      // .catch(() => {
      //   this.getCateList();
      // });
    },
    openCategory(category) {
      if (category.length > 0) {
        category.map(item => {
          window.open_category[item.category_id] = { ...item };
          if (item.categories.length > 0) {
            this.openCategory(item.categories);
          }
        });
      }
      return;
    },
    getCateList() {
      let url = "api/store/category";
      if (this.userRule) {
        url = "api/store/category/category_part_tree_home/" + this.activity_id;
      }
      this.$reqGet(url).then(res => {
        this.category = res.data.data;
        if (url === "api/store/category") {
          this.$store.commit("setCategory", this.category);
        }
        if (!window.open_category[470]) {
          this.openCategory(this.category);
        }
        this.$util.setSessionStorage({
          category: JSON.stringify(this.category)
        });
        if (this.$route.query.type) {
          this.curCategoryType = this.$route.query.type;
          this.category.map(item => {
            if (item.type == this.curCategoryType) {
              this.curCategory = item.name;
              this.secondCategory = item.categories;
            } else if (
              this.curCategoryType == "home" &&
              item.type == "jdcate"
            ) {
              this.curCategory = item.name;
              this.secondCategory = item.categories;
            }
          });
        } else {
          if (Object.keys(Object(this.category)).length === 0) {
            return;
          }
          this.curCategory = this.category[0].name;

          this.secondCategory = this.category[0].categories;
        }
      });
    },
    clickCategory(item) {
      if (item == "home") {
        this.curCategory = "- 请选择分类 -";
        this.curCategoryType = "home";
      } else {
        this.curCategory = item.name;
        this.curCategoryType = item.type;
        this.secondCategory = item.categories;
      }
    },
    switchCategoryLeft() {
      let len = this.category.length;
      this.curCategoryIndex--;
      if (this.curCategoryIndex === -1) {
        this.curCategoryIndex = len - 1;
      }
      this.curCategory = this.category[this.curCategoryIndex].name;
      this.secondCategory = this.category[this.curCategoryIndex].categories;
      this.curCategoryType = this.category[this.curCategoryIndex].type;
    },
    switchCategoryRight() {
      let len = this.category.length;
      this.curCategoryIndex++;
      if (this.curCategoryIndex === len) {
        this.curCategoryIndex = 0;
      }
      this.curCategory = this.category[this.curCategoryIndex].name;
      this.secondCategory = this.category[this.curCategoryIndex].categories;
      this.curCategoryType = this.category[this.curCategoryIndex].type;
    },
    showThirdCategory(item) {
      this.thirdCategory = item.categories;
    },
    showFourthCategory(item) {
      this.fourthCategory = item.categories;
    }
  }
};
</script>

<style lang="less" scoped>
.nav-wrap {
  .w {
    position: relative;
    height: 40px;
  }
  background-color: #fff;
  .select-nav {
    position: relative;
    display: inline-block;
    width: 200px;
    height: 41px;
    line-height: 41px;
    background-color: #4ac0fd;
    color: #fff;
    text-align: center;
    font-size: 16px;
    z-index: 100;
    &:hover .sub-nav,
    &:hover .third-nav {
      display: block;
    }
    i {
      position: absolute;
      top: 0;
      width: 25px;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
    }
    &:hover i {
      background-color: #3fabe3;
    }
    i:first-child {
      left: 0;
    }
    i:nth-child(2) {
      right: 0;
    }
    .sub-nav {
      display: none;
      position: absolute;
      top: 40px;
      left: 0;
      width: 200px;
      height: 455px;
      overflow: hidden;
      background: rgba(0, 0, 0, 1);
      color: #fff;
      z-index: 1000;
      font-size: 14px;
      box-sizing: border-box;
      overflow-y: scroll;
      li {
        padding: 2px 0;
        line-height: 20px;
        cursor: pointer;
        &:hover {
          background-color: rgba(255, 255, 255, 1);
          color: #e2333f;
        }
      }
    }
    .third-nav {
      display: none;
      position: absolute;
      left: 200px;
      z-index: 1988;
      width: 1000px;
      height: 455px;
      background: #fff;
      color: #333;
      overflow: hidden;
      font-size: 14px;
      font-weight: bold;
      .fourth-nav a {
        font-weight: normal;
        font-size: 13px;
        margin-left: 4px;
        letter-spacing: 1px;
        cursor: pointer;
        &:hover {
          color: #e2333f;
        }
        &:hover:first-letter {
          color: #999;
        }
      }
      .el-row {
        text-align: left;
        padding-left: 32px;
        line-height: 30px;
        display: flex;
        align-items: center;
        .category-name {
          width: 85px;
          font-weight: bold;
          font-size: 14px;
          cursor: pointer;
          &:hover {
            color: #e2333f;
          }
        }
        .fourth-nav {
          position: relative;
          margin-left: 20px;
          width: 850px;
          min-height: 30px;
        }
      }
    }
  }
  .w > a {
    float: left;
    font-size: 20px;
    color: #000;
    line-height: 40px;
    margin-left: 30px;
    // margin-top:-10px;
    max-width: 100px;
    max-height: 40px;
    cursor: pointer;
    overflow: hidden;
  }
  .w > a:nth-child(2) {
    margin-left: 40px;
  }
  a:hover,
  a.actived {
    color: #fc6823;
  }
  span {
    position: absolute;
    right: 0;
    color: #fd6c17;
    margin-top: 10px;
    img {
      width: 20px;
      height: 20px;
      // margin-top: 10px;
    }
  }
}
.headline {
  position: relative;
  top: 0.5px;
  height: 3px;
  background-image: url("../assets/images/headline.png");
  background-size: cover;
  background-position: center;
}
@keyframes fadeIn {
  from {
    width: 0;
  }
  to {
    width: 86px;
  }
}
@keyframes fadeInTel {
  from {
    width: 0;
  }
  to {
    width: 190px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-nav.vue